import { useEffect } from "react";
import type { TablePaginationConfig } from "antd";
import type { FilterValue, SorterResult, TableCurrentDataSource } from "antd/es/table/interface";
import type { AppTableOnChange } from "../types/on-change";
import { getAppTablePagination } from "../utils/get-app-table-pagination";

export const useChangeEvent = <T>(
  _pagination: TablePaginationConfig,
  onChange?: AppTableOnChange<T>,
) => {
  useEffect(() => {
    onChange?.(getAppTablePagination(_pagination));
  }, []);

  const getSorter = <I>(sorter: SorterResult<I> | SorterResult<I>[]): SorterResult<I> => {
    return Array.isArray(sorter) ? sorter[0] : sorter;
  };

  return (
    pagination: TablePaginationConfig,
    filters: Record<string, FilterValue | null>,
    sorter: SorterResult<T> | SorterResult<T>[],
    extra: TableCurrentDataSource<T>,
  ) => {
    onChange?.(getAppTablePagination(pagination), filters, getSorter(sorter), extra);
  };
};
